import styled from 'styled-components/native';

export const Container = styled.View`
	justify-content: center;
	align-items: center;
	background-color: rgba(3, 15, 28, 0.7);
`;
